import { useState, useEffect, useCallback, useRef } from 'react';
import { createErrorResponse } from 'Helpers/ApiHelpers';

const useApiData = (fetchFunction, dependencies = []) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchFunctionRef = useRef(fetchFunction);
  const dependenciesRef = useRef(dependencies);

  // Keep refs updated
  useEffect(() => {
    fetchFunctionRef.current = fetchFunction;
    dependenciesRef.current = dependencies;
  });

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await fetchFunctionRef.current();
      setData(result);
    } catch (err) {
      const errorResponse = createErrorResponse(err);
      setError(errorResponse);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Use JSON.stringify to create a stable dependency key
  const dependencyKey = JSON.stringify(dependencies);

  useEffect(() => {
    fetchData();
  }, [fetchData, dependencyKey]);

  const refetch = useCallback(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading, error, refetch };
};

export default useApiData;
